import { createSlice } from '@reduxjs/toolkit';

import type { ModalInitialStateType, ModalTypes } from 'src/helper/shared-types';
import reducers from './reducers';

const INITIAL_MODAL_STATE: ModalTypes = { isVisible: false, extraProps: {} };

const initialState: ModalInitialStateType = {
  confirmationModal: INITIAL_MODAL_STATE,
  mfaConfigurationModal: INITIAL_MODAL_STATE,
  vendorManage: INITIAL_MODAL_STATE,
  commonDeleteModal: INITIAL_MODAL_STATE,
  imageSlidesModal: INITIAL_MODAL_STATE,
  blockOutTimeModal: INITIAL_MODAL_STATE,
  workOrderActions: INITIAL_MODAL_STATE,
  addEditQuoteMaterialModal: INITIAL_MODAL_STATE,
  addEditTagModal: INITIAL_MODAL_STATE,
  dualActionModal: INITIAL_MODAL_STATE,
  scheduleVendorAssignTypeModal: INITIAL_MODAL_STATE,
  commonModal: INITIAL_MODAL_STATE,
  newServiceRequest: INITIAL_MODAL_STATE,
  rejectServiceRequest: INITIAL_MODAL_STATE,
  schedulingBlockoutModal: INITIAL_MODAL_STATE,
  selectedPropertiesModal: INITIAL_MODAL_STATE,
  resetPasswordModal: INITIAL_MODAL_STATE,
};

const modals = createSlice({
  name: 'modals',
  initialState,
  reducers,
});

export const {
  updateVisibility,
  updateCommonModalLoadingState,
  updateConfirmationLoadingState,
  updateCommonDeleteModalLoadingState,
  updateWorkOrderActionModalLoadingState,
  updateDualModalLoadingState,
  updateQuoteMaterialModalLoadingState,
} = modals.actions;

export default modals.reducer;
